import React, { useEffect, useRef } from "react";

// SASS
import "./Part10.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import roundLabelImg from "../../assets/img/Round-Label.png";
import sprayImg from "../../assets/img/Spray1.png";
import bubble1Img from "../../assets/img/bubbles_4.png";
import bubble2Img from "../../assets/img/Bubbles.png";
import bubble3Img from "../../assets/img/Bubbles_5.png";

// FUNCTION EXPORT
export default function Part10({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "fade in text 2" },
    { stepNumber: "2", height: null, description: "fade in text 3, label" },
    { stepNumber: "3", height: null, description: "fade in text 4" },
    { stepNumber: "4", height: null, description: "spacer" },
  ];

  // REFS
  const text2El = useRef(null);
  const text3El = useRef(null);
  const text4El = useRef(null);
  const labelEl = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(text2El.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(text3El.current, direction);
            animate.fadeInOnEnter(labelEl.current, direction);
            break;
          }
          case "3": {
            animate.fadeInOnEnter(text4El.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(text2El.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(text3El.current, direction);
            animate.fadeOutOnExit(labelEl.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnExit(text4El.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part10">
          <div className="part10__text part10__text--1">
            In dry environments, the disinfectant may dry before the contact
            <br />
            time is finished.
          </div>
          <div className="part10__text part10__text--2" ref={text2El}>
            If this happens
            <div className="part10__bubble part10__bubble--1 float delay-random-1">
              <img src={bubble1Img} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="part10__text part10__text--3" ref={text3El}>
            review the <br />
            instructions from <br /> the manufacturer
          </div>
          <div className="part10__label" ref={labelEl}>
            {" "}
            <div className="part10__bubble part10__bubble--2 float delay-random-1">
              <img src={bubble2Img} alt="" className="img-fluid" />
            </div>
            <img src={roundLabelImg} alt="" className="img-fluid label" />
            <div className="spray-img spray-img-1">
              <img src={sprayImg} alt="" className="img-fluid" />
            </div>
            <div className="spray-img spray-img-2">
              <img src={sprayImg} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="part10__text part10__text--4" ref={text4El}>
            or consider reapplying another layer of the disinfectant to reach
            the contact time to kill germs.
            <div className="part10__bubble part10__bubble--3 float delay-random-3">
              <img src={bubble3Img} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
